export default "__VITE_ASSET__BYcLAJ$y__"